import { AutocompleteSdk, CartSdk, FeatureStatesSdk, type Locale, TrafficInfoSdk } from 'invictus-sdk-typescript'

import { SdkFactory } from '@Services/SdkFactory'

import { getWidgetFrontendApiConfiguration } from '../utils/config'

export class WidgetSdkFactory extends SdkFactory {
  static getAutocompleteSDK(locale: Locale, widgetUrl?: string): AutocompleteSdk {
    const userSdk = this.getUser(locale)

    return AutocompleteSdk.init(getWidgetFrontendApiConfiguration(widgetUrl), userSdk)
  }

  static getCart(locale: Locale): CartSdk {
    const userSdk = this.getUser(locale)

    return CartSdk.init(getWidgetFrontendApiConfiguration(), userSdk)
  }

  static getTrafficInfoSDK(locale: Locale, widgetUrl?: string): TrafficInfoSdk {
    const userSdk = this.getUser(locale)

    return TrafficInfoSdk.init(getWidgetFrontendApiConfiguration(widgetUrl), userSdk)
  }

  static getFeatureStatesSDK(locale: Locale, widgetUrl?: string): FeatureStatesSdk {
    const userSdk = this.getUser(locale)

    return FeatureStatesSdk.init(getWidgetFrontendApiConfiguration(widgetUrl), userSdk)
  }
}
